import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  COOKIE_CONSENT_EVENT,
  hasAnalyticsConsent,
  initGoogleAnalytics,
  trackPageView,
} from '../utils/googleAnalytics';

const GoogleAnalytics = () => {
  const location = useLocation();
  const path = `${location.pathname}${location.search}`;
  const pathRef = useRef(path);
  pathRef.current = path;

  useEffect(() => {
    if (hasAnalyticsConsent()) {
      initGoogleAnalytics();
    }

    const onConsentChange = () => {
      // First accept only. A later navigation is tracked by the path effect,
      // and init returns false once gtag is already configured.
      if (initGoogleAnalytics()) {
        trackPageView(pathRef.current);
      }
    };

    window.addEventListener(COOKIE_CONSENT_EVENT, onConsentChange);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, onConsentChange);
  }, []);

  useEffect(() => {
    trackPageView(path);
  }, [path]);

  return null;
};

export default GoogleAnalytics;
